let ulSliderComponentGutter = document.getElementById(url_slider_gutter_section_id)
l_r_switch = document.getElementsByClassName('switch_div')

if (l_r_switch.length > 0) {

    let rSliderComponentGutter = document.getElementById('r_slider_component_gutter')
    let lSliderComponentGutter = document.getElementById('l_slider_component_gutter')

    // 添加滚动事件监听器
    ulSliderComponentGutter.addEventListener('scroll', function(e) {
        // 计算右边剩余距离
        let rightDistance = ulSliderComponentGutter.scrollWidth - ulSliderComponentGutter.clientWidth - ulSliderComponentGutter.scrollLeft;
        // 左边已滚动距离
        let leftDistance = ulSliderComponentGutter.scrollLeft;
        if (rightDistance == 0) {
            rPathElements = rSliderComponentGutter.querySelectorAll('svg path')
            rPathElements.forEach(pathElement => {
                pathElement.setAttribute('fill', '#EBEBEB')
            });
        } else {
            rPathElements = rSliderComponentGutter.querySelectorAll('svg path')
            rPathElements.forEach(pathElement => {
                pathElement.setAttribute('fill', '#121212')
            });
        }

        if (leftDistance == 0) {
            lPathElements = lSliderComponentGutter.querySelectorAll('svg path')
            lPathElements.forEach(pathElement => {
                pathElement.setAttribute('fill', '#EBEBEB')
            });
        } else {
            lPathElements = lSliderComponentGutter.querySelectorAll('svg path')
            lPathElements.forEach(pathElement => {
                pathElement.setAttribute('fill', '#121212')
            });
        }
    });


    lSliderComponentGutter.addEventListener('click', e => {
        // 左边已滚动距离
        let leftDistance = ulSliderComponentGutter.querySelector('li').offsetWidth;
        console.log(leftDistance)
        if (leftDistance <= 0) {
            // 已经在最左边了
            return
        }
        // 滚动距离
        let scrollAmount = 400
        // 计算左边已滚动距离
        let currentScrollLeft = ulSliderComponentGutter.scrollLeft;
        // 计算即将要滚动到的位置
        let newScrollLeft = currentScrollLeft - scrollAmount;
        // 执行滚动操作
        ulSliderComponentGutter.scrollTo({
            left: newScrollLeft,
            behavior: 'smooth' // 使用平滑滚动效果
        });


    })



    rSliderComponentGutter.addEventListener('click', e => {
      
        // 计算右边剩余距离
        let rightDistance = ulSliderComponentGutter.scrollWidth - ulSliderComponentGutter.clientWidth - ulSliderComponentGutter.scrollLeft;

        // 如果右边已经没有剩余距离，则无需继续向右滚动
        if (rightDistance <= 0) {
            return;
        }

        // 计算当前每次点击应该移动的距离，可以根据需要调整移动的距离
        let scrollAmount = ulSliderComponentGutter.querySelector('li').offsetWidth; // 每次点击移动的距离，设置为 ul 下的 li 宽度

        // 计算即将要滚动到的位置
        let newScrollLeft = ulSliderComponentGutter.scrollLeft + scrollAmount;

        // 执行滚动操作
        ulSliderComponentGutter.scrollTo({
            left: newScrollLeft,
            behavior: 'smooth' // 使用平滑滚动效果
        });

    })
    
}